import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  CALL_STATUS,
  CALL_TYPE,
  CAMPAIGN_LIST,
  CATEGORY,
  CLOSED_SUB_CATEGORY,
  COLD_SUB_CATEGORY,
  ENQUIRY_TYPE,
  GET_CATEGORY_AND_SUBCATEGORY_LIST,
  GET_CSE_LIST,
  GET_DETAILS_BY_MOBILE_NUMBER,
  GET_TIMELINE,
  HOT_SUB_CATEGORY,
  LEAD_EDIT_API,
  PENDING_SUB_CATEGORY,
  REGION_TO_BDM,
  STATE_API,
  STATE_TO_REGION,
  SUPERVISOR_LEAD_EDIT_API,
  TITLE,
  WARM_SUB_CATEGORY,
} from "../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  InputAdornment,
  MenuItem,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import LongTextComponent from "../Leads Page/LongTextComponent";
import Loader from "../reusable Component/Loader";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TimelineDialog from "../reusable Component/TimelineDialog";
import EditIcon from "@mui/icons-material/Edit";
import ModalComponent from "../reusable Component/modalComponent";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TimelineIcon from "@mui/icons-material/Timeline";
import Cookies from "js-cookie";

function LeadDetailsPageComponent({}) {
  const location1 = useLocation();
  const leadId = location1.state?.leadId;
  const MobileNo = location1.state?.MobileNo;

  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
    const [categoryList, setCategoryList] = useState([]);

  const fetchData = () => {
    axios
      .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${MobileNo}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { lead } = response.data;
        setData(lead);
        setIsPresent(true);
        setFetchedLeadData(lead);
      })
      .catch((error) => {
        console.error("Error fetching lead details:", error);
      });
  };

  const fetchAllLeadSource = () => {
    axios
      .get(`${CAMPAIGN_LIST}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { data } = response.data;
        setCampaignList(data);
      })
      .catch((error) => {
        console.error("Error fetching lead details:", error);
      });
  };

  useEffect(() => {
    fetchData();
    fetchAllLeadSource();
    fetchCseList();
  }, []);

  const [cseList, setCseList] = useState([]);
  const fetchCseList = async () => {
    try {
      const response = await axios.get(`${GET_CSE_LIST}`);
      setCseList(response.data);
    } catch (error) {
      console.error("Error fetching inquiry types:", error);
    }
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const [timelineOpen, setTimelineOpen] = useState(false);
  const [timelineLogs, setTimelineLogs] = useState([]);

  const handletimelineClick = () => {
    setTimelineOpen(true);

    axios
      .get(`${GET_TIMELINE}/${leadId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { leadLogs } = response.data;
        setTimelineLogs(leadLogs);
      })
      .catch((error) => {});
  };

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  //Feilds Added
  const [project, setProject] = useState("");
  const [callType, setCallType] = useState("");
  const [title, setTitle] = useState("");
  const [siteLocationAddress, setSiteLocationAddress] = useState("");
  const [leadTransferDate, setLeadTransferDate] = useState(undefined);
  const [leadOwner, setLeadOwner] = useState("");
  const [agentRemark, setAgentRemark] = useState("");
  const [followUpDate, setFollowUpDate] = useState(undefined);
  const [closureMonth, setClosureMonth] = useState(undefined);
  const [callStatus, setCallStatus] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [mailId, setMailId] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [region, setRegion] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({
      id: null,
      name: "",
    });
    const [selectedSubCategory, setSelectedSubCategory] = useState({
      id: null,
      name: "",
    });
  const [leadSource, setLeadSource] = useState("");
  const [enquiryType, setEnquiryType] = useState("");
  const [location, setLocation] = useState("");
  const [otherLocation, setOtherLocation] = useState("");

  //Other
  const [bdmID, setBdmId] = useState("");
  const [agentId, setAgentId] = useState("");
  const [regionName, setRegionName] = useState("");
  const [regionNameList, setRegionNameList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [filteredLeadOwners, setFilteredLeadOwners] = useState([]);
  const [filteredProject, setFilteredProject] = useState([]);
  const [bdmList, setBdmList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [isOtherLocation, setIsOtherLocation] = useState(true);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [leadID, setLeadID] = useState("");
  const [regionId, setRegionId] = useState("");
  const [isRegionUpdate, setIsRegionUpdate] = useState(false);
  const [isPresent, setIsPresent] = useState(false);
  const [isLocationUpdate, setIsLocationUpdate] = useState(false);
  const [isProjectUpdate, setIsProjectUpdate] = useState(false);

  //Validation Error
  const [agentRemarkError, setAgentRemarkError] = useState("");
  const [projectError, setProjectError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [middleNameError, setMiddleNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [whatsappNumberError, setWhatsappNumberError] = useState("");
  const [alternateNumberError, setAlternateNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [stateError, setStateError] = useState("");
  const [regionError, setRegionError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [leadSourceError, setLeadSourceError] = useState("");
  const [enquiryTypeError, setEnquiryTypeError] = useState("");
  const [callStatusError, setcCallStatusError] = useState("");
  const [callTypeError, setCallTypeError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [followUpDateError, setFollowUpDateError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [closureMonthError, setClosureMonthError] = useState("");
  const [leadOwnerError, setLeadOwnerError] = useState("");


  useEffect(() => {
      handleGetCategoryAndSubCategory();
    }, []);
  
    
  
    const handleGetCategoryAndSubCategory = () => {
      setCategoryLoading(true); // Start loading
      axios
        .get(`${GET_CATEGORY_AND_SUBCATEGORY_LIST}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          setCategoryList(response.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
          handleLogout();
        } else {
          console.error("Failed to fetch data. Please try again.");
        }
        })
        .finally(() => {
          setCategoryLoading(false); // Stop loading
        });
    };
  
    const handleLogout = () => {
          localStorage.clear();
          Cookies.remove("authToken", { path: "/" });
          navigate("/");
          navigate(0);
        };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    // Validate for empty value
    if (value.trim() === "") {
      setMobileNumber("");
      handleReset();
    } else {
      // Validate for numeric characters only and length
      if (/^\d{0,10}$/.test(value)) {
        setMobileNumber(value);
      }
    }
  };

  const fetchStateAndRegionByPincode = (value) => {
        setPincodeLoading(true);
        axios
          .get(`${STATE_API}/${value}`,{
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          })
          .then((response) => {
            console.log(response);
    
            setState(response?.data?.stateName);
    
            fetchRegionFromState(response?.data?.stateName);
            setStateError("");
    
            //Map region so can be used for region feild
            const namesArray = response.data.places.map((item) => ({
              names: item.placeName,
            }));
    
            setLocationList(namesArray);
          })
          .catch((error) => {
            console.error("Error fetching pincode data:", error);
            setMessage(error.response?.data?.error || "Failed to fetch data");
            setSeverity("error");
            setOpenSnackbar(true);
            setStateError("Failed to fetch state. Please try again.");
          })
          .finally(() => {
            setPincodeLoading(false); // Stop loading
          });
      };

  // const fetchStateAndRegionByPincode = (value) => {
  //   setPincodeLoading(true);
  //   axios
  //     .get(`https://api.postalpincode.in/pincode/${value}`)
  //     .then((response) => {
  //       if (response.data[0].PostOffice == null) {
  //         setSeverity("error");
  //         setMessage(response.data[0].Message);
  //         setOpenSnackbar(true);
  //         return;
  //       }
  //       setState(
  //         response.data[0].PostOffice[0].State === "Chattisgarh"
  //           ? "Chhattisgarh"
  //           : response.data[0].PostOffice[0].State
  //       );

  //       fetchRegionFromState(
  //         response.data[0].PostOffice[0].State === "Chattisgarh"
  //           ? "Chhattisgarh"
  //           : response.data[0].PostOffice[0].State
  //       );

  //       //Map region so can be used for region feild
  //       const namesArray = response.data[0].PostOffice.map((item) => ({
  //         names: item.Name,
  //       }));

  //       setLocationList(namesArray);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching pincode data:", error);
  //     })
  //     .finally(() => {
  //       setPincodeLoading(false); // Stop loading
  //     });
  // };

  const fetchRegionFromState = (state_name) => { 
    axios
      .get(`${STATE_TO_REGION}/${state_name}`)
      .then((response) => {
        setRegionNameList(response.data);
        if (response.data.length === 1) {
          fetchLeadOwnerfromRegion(response.data[0].RegionId);
        }
      })
      .catch((error) => {
        console.error("Error fetching pincode data:", error);
      });
  };

  const fetchLeadOwnerfromRegion = (regionName) => {
    axios
      .get(`${REGION_TO_BDM}/${regionName}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
      .then((response) => {
        const rawData = response.data.data || [];
  
        // Deduplicate BDMs by EmployeeName
        const bdmMap = new Map();
        rawData.forEach((employee) => {
          if (!bdmMap.has(employee.EmployeeName)) {
            bdmMap.set(employee.EmployeeName, {
              EmployeeId: employee.EmployeeId,
              EmployeeName: employee.EmployeeName,
              leadSources: employee.leadSources || [],
              project: employee.Project,
            });
          }
        });
  
        const uniqueBdmList = Array.from(bdmMap.values());
        setBdmList(uniqueBdmList);
  
        if (uniqueBdmList.length === 1) {
          const [singleBDM] = uniqueBdmList;
          setBdmId(singleBDM.EmployeeId);
          setLeadOwner(singleBDM.EmployeeName); // Store name
          setProject(singleBDM.project);
        } else {
          setBdmId("");
          setLeadOwner("");
          setProject("");
        }
  
        // Deduplicate Projects by name
        const uniqueProjects = Array.from(
          new Set(rawData.map((emp) => emp.Project))
        )
          .filter(Boolean)
          .map((project) => ({ label: project }));
  
        setProjectList(uniqueProjects);
      })
      .catch((error) => {
        console.error("Error fetching BDM data:", error);
        setSeverity("warning");
        setMessage(error.response?.data?.message || "Failed to fetch data");
        setOpenSnackbar(true);
        setLeadOwner("");
        setBdmList([]);
        setProjectList([]);
      });
  };
  

  // When Lead Owner is selected
  const handleProjectChange = (selectedProject) => {
    // Filter BDM list based on the selected lead source
    const filteredProject = bdmList.filter(
      (bdm) => bdm.EmployeeId === selectedProject
    );

    // Extract unique lead owners
    const uniqueProject = Array.from(
      new Set(filteredProject.map((owner) => owner.project))
    );

    setFilteredProject(uniqueProject);
  };

  const setFetchedLeadData = (lead) => {
    setLeadID(lead.id);
    setBdmId(lead.BDMId);
    setAgentId(lead.AgentId);
    setFilteredProject([lead.Project] || []);
    setCallType(lead.call_type || "");
    setTitle(lead.CustomerName?.split(" ")[0] || ""); // Assuming no title in the data
    setSiteLocationAddress(lead.site_location_address || "");
    setLeadTransferDate(lead.lead_transfer_date || undefined);
    setLeadOwner(lead.BDM?.EmployeeName || ""); // Lead Owner is BDM's name
    setAgentRemark(lead.agent_remark || "");
    setFollowUpDate(lead.follow_up_date || undefined);
    setClosureMonth(lead.close_month || undefined);
    setCallStatus(lead.call_status || "");
    setFirstName(lead.CustomerName?.split(" ")[1] || "");
    setMiddleName(lead.CustomerName?.split(" ")[2] || ""); // No middle name in the data
    setLastName(lead.CustomerName?.split(" ")[3] || "");
    setMobileNumber(lead.MobileNo || "");
    setWhatsappNumber(lead.WhatsappNo || "");
    setAlternateNumber(lead.AlternateMobileNo || "");
    setMailId(lead.CustomerMailId || "");
    setPincode(lead.pincode || "");
    setState(lead.state_name || "");
    setRegion(lead.region_name || "");

    setSelectedCategory({ id: lead.categoryId , name: lead.category });
    setSelectedSubCategory({ id: lead.subCategoryId, name: lead.sub_category });

    setLeadSource(lead.source_of_lead_generated || "");
    setEnquiryType(lead.InquiryType || "");
    setLocation(lead.location || "");
    setProject(lead.Project || "");
    setRegionId(lead.RegionId || "");
    setRegionName(lead.region_name || "");
  };

  //Reset the form Values
  const handleReset = () => {
    setEnquiryType("");
    setCallType("");
    setCallStatus("");
    setProject("");
    setFirstName("");
    setMiddleName("");
    setTitle("");
    setLastName("");
    setAlternateNumber("");
    setWhatsappNumber("");
    setMailId("");
    setPincode("");
    setState("");
    setRegion("");
    setLocation("");
    setSiteLocationAddress("");
    setSelectedCategory({ id: null, name: "" });
    setSelectedSubCategory({ id: null, name: "" });
    setAgentRemark("");
    setFollowUpDate(undefined);
    setLeadTransferDate(undefined);
    setLeadOwner("");
    setLeadSource("");
    setClosureMonth(undefined);
    setCallStatus("");
    setState("");
    setProject("");
    setRegion("");

    setCallTypeError("");
    setcCallStatusError("");

    //Other
    setBdmId("");
    setRegionName("");
    setIsRegionUpdate(false);
    setIsLocationUpdate(false);
    setIsProjectUpdate(false);
  };

  const handleEdit = () => {
    if (!callStatus) {
      setcCallStatusError("Call Status is required.");
      return;
    }
    if (!callType) {
      setCallTypeError("Call Type is required.");
      return;
    }

    const formData = {
      AgentId: agentId || "",
      InquiryType: enquiryType || "",
      call_status: callStatus || "",
      call_type: callType || "",
      site_location_address: siteLocationAddress || "",
      Project: project || "",
      CustomerName: `${title} ${firstName} ${middleName} ${lastName}`,
      MobileNo: mobileNumber || "",
      AlternateMobileNo: alternateNumber || "",
      WhatsappNo: whatsappNumber || "",
      CustomerMailId: mailId || "",
      state_name: state || "",
      region_name:
        regionNameList.length === 1
          ? regionNameList[0].RegionName
          : regionName || null,
      location: location === 'other' ? (otherLocation || "") : (location || ""),
      category: selectedCategory.name || "",
      categoryId: selectedCategory.id || null,
      sub_category: selectedSubCategory.name || "",
      subCategoryId: selectedSubCategory.id || null,
      agent_remark: agentRemark || "",
      follow_up_date: followUpDate == undefined ? null : followUpDate,
      lead_owner: leadOwner === "" ? null : leadOwner,
      source_of_lead_generated:
        empDetails.Campaigns.length == 1
          ? empDetails.Campaigns[0].CampaignId
          : leadSource,
      BDMId:
        bdmID === ""
          ? [2, 3].includes(Number(localStorage.getItem("empRole")))
            ? Number(localStorage.getItem("username"))
            : null
          : bdmID == null
          ? null
          : Number(bdmID),
      pincode: pincode || "",
      lead_created_by: Number(localStorage.getItem("empRole")),
      close_month: closureMonth === "" ? null : closureMonth,
      RegionId:
        regionNameList.length === 1
          ? regionNameList[0].RegionId
          : regionId || null,
      updated_by: empDetails.EmployeeId,
      remarks: agentRemark || "",
      action_type: "Lead Edited by Supervisor",
    };

    axios
      .put(`${SUPERVISOR_LEAD_EDIT_API}/${leadId}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { lead } = response.data;
        console.log(lead);

        setSeverity("success");
        setMessage(response.data.message);
        setOpenSnackbar(true);
        setShowEdit(false);
        fetchData();
        handleReset();
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response) {
          console.log(error.response.data.message);
          if (error.response.data.errors) {
            const errorData = error.response.data.errors;
            console.log(errorData);

            if (errorData.bdm_remark) setAgentRemarkError(errorData.bdm_remark);
            if (errorData.project) setProjectError(errorData.project);
            if (errorData.first_name) setFirstNameError(errorData.first_name);
            if (errorData.middle_name)
              setMiddleNameError(errorData.middle_name);
            if (errorData.last_name) setLastNameError(errorData.last_name);
            if (errorData.mobile_number)
              setMobileNumberError(errorData.mobile_number);
            if (errorData.whatsapp_number)
              setWhatsappNumberError(errorData.whatsapp_number);
            if (errorData.alternate_number)
              setAlternateNumberError(errorData.alternate_number);
            if (errorData.email) setEmailError(errorData.email);
            if (errorData.pincode) setPincodeError(errorData.pincode);
            if (errorData.state) setStateError(errorData.state);
            if (errorData.region) setRegionError(errorData.region);
            if (errorData.category) setCategoryError(errorData.category);
            if (errorData.sub_category)
              setSubCategoryError(errorData.sub_category);
            if (errorData.lead_source)
              setLeadSourceError(errorData.lead_source);
            if (errorData.InquiryType)
              setEnquiryTypeError(errorData.InquiryType);
            if (errorData.call_status)
              setcCallStatusError(errorData.call_status);
            if (errorData.call_type) setCallTypeError(errorData.call_type);
            if (errorData.location) setLocationError(errorData.location);
            if (errorData.follow_up_date)
              setFollowUpDateError(errorData.follow_up_date);
            if (errorData.title) setTitleError(errorData.title);
            if (errorData.closure_month)
              setClosureMonthError(errorData.closure_month);
            if (errorData.BDMId) setLeadOwnerError(errorData.BDMId);
          }

          setSeverity("error");
          setMessage(error.response.data.message);
          setOpenSnackbar(true);
        }
      });
  };

  const [open, setOpen] = useState(false);

  const [showEdit, setShowEdit] = useState(false);

  return (
    <>
      {loading && <Loader open={loading} />}
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className={`${leadFormStyles.accordian_heading} h-auto`}
        >
          <Typography sx={{ flex: 1 }}>Lead Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              position: "relative", // Allow absolute positioning for the button
              // "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
          >
            <Stack direction={"row"}>
              <Grid container spacing={2} p={3}>
                {[
                  {
                    label: "Customer Name",
                    value: data.CustomerName || "-",
                  },
                  { label: "Mobile Number", value: data.MobileNo || "-" },
                  {
                    label: "Alternate Mobile Number",
                    value: data.AlternateMobileNo || "-",
                  },
                  {
                    label: "Whatsapp Number",
                    value: data.WhatsappNo || "-",
                  },
                  {
                    label: "Customer Mail ID",
                    value: data.CustomerMailId || "-",
                  },
                  { label: "Postal Pincode", value: data.pincode || "-" },
                  { label: "State", value: data.state_name || "-" },
                  { label: "Region Name", value: data.region_name || "-" },
                  { label: "Branch Name", value: data.branchName || "-" },
                  {
                    label: "Site Location Address",
                    value: data.site_location_address || "-",
                  },
                  {
                    label: "Follow-up Date",
                    value:
                      data.follow_up_date == null
                        ? "-"
                        : formatDate(data.follow_up_date),
                  },
                  {
                    label: "Lead Transfer Date",
                    value:
                      data.lead_transfer_date == null
                        ? "-"
                        : formatDate(data.lead_transfer_date),
                  },
                  {
                    label: "Date of First Calling",
                    value:
                      data.createdDate == null
                        ? "-"
                        : formatDate(data.createdDate),
                  },
                  {
                    label: "Campaign",
                    value:
                      campaignList.find(
                        (campaign) =>
                          campaign.CampaignId === data.source_of_lead_generated
                      )?.CampaignName || "-",
                  },
                  { label: "Lead Owner", value: data.BDM?.EmployeeName || "-" },
                  {
                    label: "Remark",
                    value: (
                      <LongTextComponent
                        text={
                          (data.agent_remark === undefined ||
                          data.agent_remark === null)
                            ? "-"
                            : data.agent_remark
                        }
                        maxLength={40}
                      />
                    ),
                  },
                  { label: "Last Action", value: data.last_action },
                ].map(({ label, value }) => (
                  <Grid item xs={12} md={4} xl={4} className="flex" key={label}>
                    <Typography
                      variant="body2"
                      className={`${leadFormStyles.label_margin}`}
                    >
                      {label}:
                    </Typography>
                    <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                      {value}
                    </Typography>
                  </Grid>
                ))}
              </Grid>

              {/* Button at the top right */}
              <div>
                <Button
                  className={`float-right`}
                  sx={{
                    minWidth: "30px",
                    fontSize: "0.8rem",
                    padding: "6px 6px",
                  }}
                  color="primary"
                  variant="contained"
                  onClick={() => handletimelineClick()}
                  size="small"
                >
                  <TimelineIcon fontSize="small" color="#fff" /> Timeline
                </Button>

                <Button
                  className={`float-right`}
                  sx={{ mt: 1 }}
                  color="primary"
                  variant="contained"
                  onClick={() => setShowEdit(true)}
                  size="small"
                >
                  <EditIcon
                    color="inherit"
                    sx={{ fontSize: "1rem", paddingRight: "2px" }}
                  />{" "}
                  Edit
                </Button>
              </div>
            </Stack>
          </Box>
        </AccordionDetails>
      </Accordion>

      <TimelineDialog
        open={timelineOpen}
        setOpen={setTimelineOpen}
        timelineLogs={timelineLogs}
        custData={data}
      ></TimelineDialog>

      {showEdit && (
        <Card>
          <CardHeader
            title="Edit Form"
            sx={{
              padding: "10px",
              borderBottom: "1px solid #ccc",
            }}
            titleTypographyProps={{
              fontSize: "1rem",
              fontWeight: 600,
            }}
            className={leadFormStyles.accordian_heading}
          />
          <CardContent>
            <Box component={"form"} noValidate autoComplete="off">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="CSE Name"
                    fullWidth
                    defaultValue=""
                    // helperText="Please select your currency"
                    size="small"
                    value={agentId}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value == "") {
                        setAgentId("");
                      } else {
                        setAgentId(value);
                      }
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  >
                    {cseList.map((eq) => (
                      <MenuItem
                        value={eq.EmployeeId}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {eq.EmployeeName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    label="Mobile Number"
                    id="outlined-size-small"
                    value={mobileNumber}
                    autoComplete="off"
                    onChange={handleMobileNumberChange}
                    size="small"
                    fullWidth
                    error={!!mobileNumberError}
                    helperText={mobileNumberError}
                    disabled
                    InputProps={{
                      inputProps: { maxLength: 10 },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    label="Call Status"
                    select
                    id="outlined-size-small"
                    value={callStatus}
                    fullWidth
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setCallStatus("");
                      } else {
                        setCallStatus(value);
                        setcCallStatusError("");
                      }
                    }}
                    size="small"
                    error={!!callStatusError}
                    helperText={callStatusError}
                  >
                    {CALL_STATUS.map((ls) => (
                      <MenuItem
                        value={ls.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {ls.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Enquiry Type"
                    fullWidth
                    defaultValue=""
                    // helperText="Please select your currency"
                    size="small"
                    value={enquiryType}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setEnquiryType("");
                      } else {
                        setEnquiryType(value);
                      }
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                    error={!!enquiryTypeError}
                    helperText={enquiryTypeError}
                  >
                    {ENQUIRY_TYPE.map((eq) => (
                      <MenuItem
                        value={eq.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {eq.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Call Type"
                    defaultValue=""
                    size="small"
                    fullWidth
                    // helperText="Please select your project"
                    value={callType}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setCallType("");
                      } else {
                        setCallType(value);
                        setCallTypeError("");
                      }
                    }}
                    error={!!callTypeError}
                    helperText={callTypeError}
                  >
                    {CALL_TYPE.map((p) => (
                      <MenuItem
                        value={p.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {p.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Title"
                    defaultValue=""
                    fullWidth
                    size="small"
                    // helperText="Please select your project"
                    value={title}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setTitle("");
                      } else {
                        setTitle(value);
                      }
                    }}
                    error={!!titleError}
                    helperText={titleError}
                  >
                    {TITLE.map((p) => (
                      <MenuItem
                        value={p.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {p.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Customer First Name"
                    id="outlined-size-small"
                    value={firstName}
                    fullWidth
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        // Allow only alphabets and spaces
                        setFirstName(value);
                      }
                    }}
                    size="small"
                    InputProps={{
                      inputProps: {
                        maxLength: 100,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                    error={!!firstNameError}
                    helperText={firstNameError}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Customer Middle Name"
                    id="outlined-size-small"
                    value={middleName}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        // Allow only alphabets and spaces
                        setMiddleName(value);
                      }
                    }}
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        maxLength: 100,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                    error={!!middleNameError}
                    helperText={middleNameError}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Customer Last Name"
                    id="outlined-size-small"
                    value={lastName}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        // Allow only alphabets and spaces
                        setLastName(value);
                      }
                    }}
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        maxLength: 100,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                    error={!!lastNameError}
                    helperText={lastNameError}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Whatsapp Number"
                    id="outlined-size-small"
                    autoComplete="off"
                    value={whatsappNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Validate for numeric characters only and length
                      if (/^\d{0,10}$/.test(value)) {
                        setWhatsappNumber(value);
                      }
                    }}
                    error={!!whatsappNumberError}
                    helperText={whatsappNumberError}
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        maxLength: 10,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Alternate Number"
                    id="outlined-size-small"
                    autoComplete="off"
                    value={alternateNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Validate for numeric characters only and length
                      if (/^\d{0,10}$/.test(value)) {
                        setAlternateNumber(value);
                      }
                    }}
                    size="small"
                    error={!!alternateNumberError}
                    helperText={alternateNumberError}
                    fullWidth
                    InputProps={{
                      inputProps: {
                        maxLength: 10,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Customer Mail ID"
                    id="outlined-size-small"
                    value={mailId}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Validate for email format
                      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        setMailId(value);
                      } else {
                        setMailId(value);
                      }
                    }}
                    error={!!emailError}
                    helperText={emailError}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Postal Pincode"
                    id="outlined-size-small"
                    value={pincode}
                    onChange={(e) => {
                      const value = e.target.value.trim();

                      // Check if the field is empty
                      if (value === "") {
                        setPincode(value);

                        return;
                      }
                      setState("");
                      setRegion("");
                      setLocation("");
                      setRegionNameList([]);
                      setIsRegionUpdate(true);
                      setIsLocationUpdate(true);
                      setIsProjectUpdate(true);

                      // Validate numeric input
                      if (/^\d{0,6}$/.test(value)) {
                        setPincode(value);

                        // Call API only when the pincode length is valid
                        if (value.length === 6) {
                          fetchStateAndRegionByPincode(value);
                        }
                      } else {
                        setPincode(value);
                      }
                    }}
                    size="small"
                    error={!!pincodeError}
                    helperText={pincodeError}
                    autoComplete="off"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        maxLength: 6, // Pincode should be 6 digits max
                        inputMode: "numeric", // Optimized for mobile numeric input
                      },
                      endAdornment: pincodeLoading ? (
                        <InputAdornment position="end">
                          <CircularProgress size={20} />
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    id="outlined-select-currency"
                    label="State"
                    value={state}
                    // onChange={handleStateChange}
                    // helperText="Please select your currency"
                    size="small"
                    error={!!stateError}
                    helperText={stateError}
                    fullWidth
                    InputProps={{
                      inputProps: {
                        pattern: "^[A-Za-z]*$",
                        title: "Only alphabetic characters are allowed",
                        readOnly: true,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  {isPresent && !isRegionUpdate ? (
                    <TextField
                      id="outlined-select-currency"
                      label="Region"
                      value={
                        isPresent
                          ? isRegionUpdate
                            ? regionNameList?.[0]?.RegionName || ""
                            : region
                          : regionNameList[0].RegionName
                      }
                      size="small"
                      
                      error={!!regionError}
                      helperText={regionError}
                      fullWidth
                      InputProps={{
                        readOnly: true, // Make the field read-only
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)",
                        },
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    />
                  ) : regionNameList.length === 1 &&
                    regionNameList[0]?.RegionName ? (
                    <TextField
                      id="outlined-select-currency"
                      label="Region"
                      value={
                        isPresent
                          ? isRegionUpdate
                            ? regionNameList?.[0]?.RegionName || ""
                            : region
                          : regionNameList[0].RegionName
                      }
                      size="small"
                      
                      error={!!regionError}
                      helperText={regionError}
                      fullWidth
                      InputProps={{
                        readOnly: true, // Make the field read-only
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)",
                        },
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Region"
                      value={region}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "") {
                          setRegion("");
                          setRegionError("Region is required.");
                        } else {
                          setRegion(value);
                          setRegionError("");

                          // Find the region name based on the selected ID
                          const selectedRegion = regionNameList.find(
                            (cl) => cl.RegionId === value
                          );
                          const regionName = selectedRegion?.RegionName || ""; // Default to empty string if not found
                          setRegionName(regionName);
                          setRegionId(selectedRegion?.RegionId);
                          fetchLeadOwnerfromRegion(value);
                        }
                      }}
                      size="small"
                      
                      error={!!regionError}
                      helperText={regionError}
                      
                      fullWidth
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    >
                      {regionNameList.map((cl) => (
                        <MenuItem key={cl.RegionId} value={cl.RegionId}>
                          {cl.RegionName}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>

                {isOtherLocation && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1 }}
                  >
                    {isPresent && !isLocationUpdate ? (
                      <TextField
                        id="outlined-select-currency"
                        label="Location"
                        value={location}
                        //  onChange={handleStateChange}
                        size="small"
                        fullWidth
                        error={!!locationError}
                        helperText={locationError}
                      />
                    ) : (
                      <TextField
                        label="Location"
                        select
                        id="outlined-size-small"
                        value={location}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.trim() === "") {
                            setLocation(value);
                          } else {
                            setLocation(value);
                            setIsOtherLocation(
                              value === "Other" ? false : true
                            );
                          }
                        }}
                        size="small"
                        fullWidth
                        error={!!locationError}
                        helperText={locationError}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            fontSize: "0.65rem",
                            marginLeft: "0",
                          },
                        }}
                      >
                        {locationList &&
                          locationList.map((pl) => (
                            <MenuItem value={pl.names}>{pl.names}</MenuItem>
                          ))}
                        <MenuItem value={"other"}>Other</MenuItem>
                      </TextField>
                    )}
                  </Grid>
                )}

                {location === "other" && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1 }}
                  >
                    <TextField
                      label="Location"
                      id="outlined-size-small"
                      autoComplete="off"
                      value={otherLocation}
                      onChange={(e) => setOtherLocation(e.target.value)}
                      size="small"
                      fullWidth
                      error={!!locationError}
                      helperText={locationError}
                    />
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Lead Source"
                    select
                    id="outlined-size-small"
                    value={leadSource}
                    onChange={(e) => {
                      const value = e.target.value;

                      setLeadSource(value);
                    }}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                    error={!!leadSourceError}
                    helperText={leadSourceError}
                  >
                    {campaignList.map((p) => (
                      <MenuItem
                        key={p.CampaignId} // Ensure unique keys
                        value={p.CampaignId}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {p.CampaignName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                                  <TextField
                                    label="Lead Owner"
                                    id="outlined-size-small"
                                    select={bdmList.length > 1}
                                    value={leadOwner}
                                    onChange={(e) => {
                                      const selectedEmployeeId = e.target.value;
                                      setLeadOwner(selectedEmployeeId);
                                      setBdmId(selectedEmployeeId);
                                      handleProjectChange(selectedEmployeeId);
                                      setLeadOwnerError("");
                                    }}
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                      readOnly: bdmList.length === 1,
                                    }}
                                    error={!!leadOwnerError}
                                    helperText={leadOwnerError}
                                  >
                                    {bdmList.length === 1 ? (
                                      <MenuItem
                                        key={bdmList[0].EmployeeId}
                                        value={bdmList[0].EmployeeId}
                                      >
                                        {bdmList[0].EmployeeName}
                                      </MenuItem>
                                    ) : (
                                      bdmList.map((p) => (
                                        <MenuItem
                                          key={p.EmployeeId}
                                          value={p.EmployeeId}
                                          sx={{
                                            borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                                            marginBottom: "8px",
                                            marginTop: "8px",
                                          }}
                                        >
                                          {p.EmployeeName}
                                        </MenuItem>
                                      ))
                                    )}
                                  </TextField>
                </Grid>

                {isPresent && !isProjectUpdate ? (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1, paddingBottom: "16px" }}
                  >
                    <TextField
                      label="Project"
                      id="outlined-size-small"
                      autoComplete="off"
                      value={project}
                      error={!!projectError}
                      helperText={projectError}
                      size="small"
                      fullWidth
                    />
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1 }}
                  >
                    {/* Check if there's only one project and set it directly */}
                    {projectList.length === 1 ? (
                      <TextField
                        id="outlined-select-currency"
                        label="Project"
                        value={projectList[0].label} // Automatically set to the only project
                        size="small"
                        InputProps={{
                          readOnly: true, // Make the field read-only when only one project exists
                        }}
                        fullWidth
                        error={!!projectError}
                        helperText={projectError}
                        sx={{
                          "& .MuiInputBase-input": {
                            color: "rgba(0, 0, 0, 0.87)",
                          },
                        }}
                      />
                    ) : (
                      <TextField
                        id="outlined-select-currency"
                        select
                        label="Project"
                        size="small"
                        value={project}
                        error={!!projectError}
                        helperText={projectError}
                        fullWidth
                        onChange={(e) => {
                          setProject(e.target.value);
                        }}
                      >
                        {projectList.map((p) => (
                          <MenuItem
                            key={p.label}
                            value={p.label}
                            sx={{
                              borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                              marginBottom: "8px",
                              marginTop: "8px",
                            }}
                          >
                            {p.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    label="Site Location Address"
                    id="outlined-size-small"
                    multiline
                    rows={4}
                    autoComplete="off"
                    value={siteLocationAddress}
                    onChange={(e) => setSiteLocationAddress(e.target.value)}
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        maxLength: 100,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <Typography variant="h5" sx={{ mt: 1, fontWeight: 700 }}>
              Disposition Summary
            </Typography>
            <Divider sx={{ mb: 2 }}></Divider>
            <Box component="form" noValidate autoComplete="off">
              <Grid container spacing={2}>
                <Grid
              item
              xs={12}
              md={6}
              xl={6}
              className={`${leadFormStyles.fields_padding}`}
              sx={{ mt: 1 }}
            >
              <TextField
                select
                label="Category"
                value={selectedCategory.name}
                fullWidth
                onChange={(e) => {
                  const selected = categoryList.find(
                    (cat) => cat.CategoryName === e.target.value
                  );
                  if (selected) {
                    setSelectedCategory({
                      id: selected.CategoryId,
                      name: selected.CategoryName,
                    });
                    setSelectedSubCategory({ id: null, name: "" }); // reset subcategory
                    setCategoryError("");
                  } else {
                    setCategoryError("Category is required.");
                  }
                }}
                size="small"
                required
                error={!!categoryError}
                helperText={categoryError}
              >
                {categoryList.map((cat) => (
                  <MenuItem key={cat.CategoryId} value={cat.CategoryName}>
                    {cat.CategoryName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              xl={6}
              className={`${leadFormStyles.fields_padding}`}
              sx={{ mt: 1 }}
            >
              <TextField
                select
                label="Sub-Category"
                value={selectedSubCategory.name}
                fullWidth
                onChange={(e) => {
                  const subcats =
                    categoryList.find(
                      (cat) => cat.CategoryId === selectedCategory.id
                    )?.subcategories || [];

                  const selectedSub = subcats.find(
                    (sub) => sub.SubCategoryName === e.target.value
                  );

                  if (selectedSub) {
                    setSelectedSubCategory({
                      id: selectedSub.SubCategoryId,
                      name: selectedSub.SubCategoryName,
                    });
                    setSubCategoryError("");
                  } else {
                    setSubCategoryError("Sub-Category is required.");
                  }
                }}
                size="small"
                required
                error={!!subCategoryError}
                helperText={subCategoryError}
              >
                {categoryList
                  .find((cat) => cat.CategoryName.toLowerCase() === selectedCategory.name.toLowerCase())
                  ?.subcategories.map((sub) => (
                    <MenuItem
                      key={sub.SubCategoryId}
                      value={sub.SubCategoryName}
                    >
                      {sub.SubCategoryName}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

                {(selectedCategory.name.toLowerCase() === "hot" ||
                  selectedCategory.name.toLowerCase() === "warm") && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1 }}
                  >
                    {isPresent ? (
                      <DatePicker
                        label="Lead Transfer Date"
                        value={dayjs(leadTransferDate)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            readOnly: true
                          },
                        }}
                      />
                    ) : (
                      <DatePicker
                        label="Lead Transfer Date"
                        format="DD/MM/YYYY"
                        onChange={(e) => {
                          {
                            const date = new Date(e.$d);
                            const year = date.getFullYear();
                            const month = ("0" + (date.getMonth() + 1)).slice(
                              -2
                            ); // Months are zero indexed, so we add 1
                            const day = ("0" + date.getDate()).slice(-2);
                            const formattedDate = `${year}-${month}-${day}`;
                            setLeadTransferDate(formattedDate);
                          }
                        }}
                        disablePast
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            readOnly: true
                          },
                        }}
                      />
                    )}
                  </Grid>
                )}

                {(selectedCategory.name.toLowerCase() === "hot" ||
                  selectedCategory.name.toLowerCase() === "warm" ||
                  selectedCategory.name.toLowerCase() === "pending") && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {isPresent ? (
                        <DateTimePicker
                          label="Follow-up Date"
                          name="startDateTime"
                          value={dayjs(followUpDate)}
                          onChange={(value) => {
                            if (!value || !dayjs(value).isValid()) {
                            } else {
                              setFollowUpDate(
                                dayjs(value).format("YYYY-MM-DDTHH:mm:ss")
                              );
                            }
                          }}
                          disablePast
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!followUpDateError,
                              helperText: followUpDateError,
                              readOnly: true
                            },
                          }}
                        />
                      ) : (
                        <DateTimePicker
                          label="Follow-up Date"
                          name="startDateTime"
                          format="DD/MM/YYYY"
                          onChange={(value) => {
                            if (!value || !dayjs(value).isValid()) {
                            } else {
                              setFollowUpDate(
                                dayjs(value).format("YYYY-MM-DDTHH:mm:ss")
                              );
                            }
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!followUpDateError,
                              helperText: followUpDateError,
                              readOnly: true
                            },
                          }}
                          disablePast
                          renderInput={(params) => <TextField {...params} />}
                        />
                      )}
                    </LocalizationProvider>
                  </Grid>
                )}

                {(selectedCategory.name.toLowerCase() === "hot" ||
                  selectedCategory.name.toLowerCase() === "warm") && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                    sx={{ mt: 1 }}
                  >
                    {isPresent ? (
                      <DatePicker
                        label={"Expected Closure Month"}
                        views={["month", "year"]}
                        value={dayjs(closureMonth)}
                        onChange={(newValue) => {
                          // newValue is the selected date object
                          const formattedValue =
                            dayjs(newValue).format("YYYY-MMM");
                          setClosureMonth(formattedValue); // Set the formatted value to state
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !!closureMonthError,
                            helperText: closureMonthError,
                            readOnly: true
                          },
                        }}
                        disablePast
                      />
                    ) : (
                      <DatePicker
                        label={"Closure Month"}
                        views={["month", "year"]}
                        onChange={(newValue) => {
                          // newValue is the selected date object
                          const formattedValue =
                            dayjs(newValue).format("YYYY-MMM");
                          setClosureMonth(formattedValue); // Set the formatted value to state
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !!closureMonthError,
                            helperText: closureMonthError,
                            readOnly: true
                          },
                        }}
                        disablePast
                      />
                    )}
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    id="outlined-multiline-static"
                    label="Remarks"
                    multiline
                    rows={4}
                    fullWidth
                    value={agentRemark}
                    inputProps={{
                      maxLength: 250,
                    }}
                    style={{ resize: "both", overflow: "auto" }}
                    onChange={(e) => {
                      const newRemark = e.target.value.slice(0, 250); // Trim to 250 characters
                      setAgentRemark(newRemark);
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                  <Typography
                    variant="body2"
                    color={
                      agentRemark.length > 250 ? "error" : "text.secondary"
                    }
                    sx={{ marginLeft: "7px" }}
                  >
                    {agentRemark.length}/250
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <div style={{ float: "right", marginBottom: "10px" }}>
              <Button
                type="submit"
                onClick={handleEdit}
                variant="contained"
                sx={{ marginRight: "5px" }}
              >
                Update
              </Button>
              {/* <Button onClick={handleReset} variant="contained">Reset</Button> */}
            </div>
          </CardContent>
        </Card>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default LeadDetailsPageComponent;
